import clsx from 'clsx';

import { AlertRuleRow } from '@/react/portainer/observability/types';
import { severityToBadgeType } from '@/react/portainer/observability/utils';

import { DetailsTable } from '@@/DetailsTable';
import { Badge } from '@@/Badge';
import { Card } from '@@/Card';

interface Props {
  alertRule: AlertRuleRow;
}

export function AlertRuleInfo({ alertRule }: Props) {
  return (
    <>
      <DetailsTable dataCy="alert-rule-info-table">
        <DetailsTable.Row label="Name">{alertRule.name}</DetailsTable.Row>
        <DetailsTable.Row label="Category">
          {alertRule.labels?.category && (
            <Badge type="info" className="text-xs">
              {alertRule.labels.category}
            </Badge>
          )}
        </DetailsTable.Row>
        <DetailsTable.Row label="Type">
          <Badge type="muted" className="text-xs">
            {alertRule.isInternal ? 'System' : 'Custom'}
          </Badge>
        </DetailsTable.Row>
        <DetailsTable.Row label="Description">
          {alertRule.description}
        </DetailsTable.Row>
        <DetailsTable.Row label="Severity">
          <Badge type={severityToBadgeType(alertRule.severity)}>
            {alertRule.severity}
          </Badge>
        </DetailsTable.Row>
        <DetailsTable.Row label="Enabled">
          {alertRule.enabled ? 'Yes' : 'No'}
        </DetailsTable.Row>
        {alertRule.updatedAt ? (
          <DetailsTable.Row label="Last updated">
            {alertRule.updatedAt}
          </DetailsTable.Row>
        ) : (
          <DetailsTable.Row label="Created">
            {alertRule.createdAt}
          </DetailsTable.Row>
        )}
      </DetailsTable>
      <div className="row">
        <div className="col-sm-12">
          <h4>Rule Summary</h4>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <Card className="flex items-start gap-2">
            <span className="text-sm">Triggers when</span>
            <span className="text-sm font-bold">
              {alertRule.conditionOperator}
            </span>
            <span className="text-sm font-bold">
              {alertRule.threshold}
              {metricTypeToSymbol(alertRule.metricType)}
            </span>
            <span className="text-sm">for</span>
            <span className="text-sm font-bold">{alertRule.duration}</span>
            <span className="text-sm">minutes</span>
            <span className="text-sm">→ severity is</span>
            <span
              className={clsx(
                'text-sm font-bold',
                severityToTextColour(alertRule.severity)
              )}
            >
              {alertRule.severity}
            </span>
          </Card>
        </div>
      </div>
    </>
  );

  function metricTypeToSymbol(metricType: AlertRuleRow['metricType']): string {
    switch (metricType) {
      case 'percentage':
        return '%';
      case 'bytes':
        return ' bytes';
      case 'raw':
      case undefined:
        return '';
    }
  }

  function severityToTextColour(severity: AlertRuleRow['severity']): string {
    switch (severity) {
      case 'critical':
        return 'text-danger';
      case 'warning':
        return 'text-warning';
      case 'info':
        return 'text-info';
    }
  }
}
